import PropTypes from "prop-types";
import React, { Component } from "react";

import {
  Button,
  Container,
  Icon,
  Menu,
  Responsive,
  Segment,
  Sidebar,
  Visibility,
  Pagination,
  Header,
  Item,
  Grid
} from "semantic-ui-react";

import * as CONSTANTS from "../assets/Constants";
import * as LINKS from "../assets/Links";

import Footer from "../components/Footer";
import MenuItems from "../components/MenuItems";
import ProjectCard from "../components/ProjectCard";

let displayRecruitment = CONSTANTS.displayRecruitment;

const getWidth = () => {
  const isSSR = typeof window === "undefined";
  return isSSR ? Responsive.onlyTablet.minWidth : window.innerWidth;
};

class DesktopNav extends Component {
  state = {};

  hideFixedMenu = () => this.setState({ fixed: false });
  showFixedMenu = () => this.setState({ fixed: true });

  render() {
    const { children } = this.props;
    const { fixed } = this.state;

    return (
      <Responsive getWidth={getWidth} minWidth={Responsive.onlyTablet.minWidth}>
        <Visibility
          once={false}
          onBottomPassed={this.showFixedMenu}
          onBottomPassedReverse={this.hideFixedMenu}
        >
          <Segment
            inverted
            textAlign="center"
            style={{
              padding: "1em 0em",
              backgroundColor: "#111111"
            }}
            vertical
          >
            <Menu
              activeIndex={3}
              fixed={fixed ? "top" : null}
              inverted={!fixed}
              pointing={!fixed}
              secondary={!fixed}
              size="large"
            >
              <MenuItems
                fixed={fixed}
                activeItem="projects"
                displayRecruitment={displayRecruitment}
              />
            </Menu>
          </Segment>
        </Visibility>
        {children}
      </Responsive>
    );
  }
}

DesktopNav.propTypes = {
  children: PropTypes.node
};

class MobileNav extends Component {
  state = {};

  handleSidebarHide = () => this.setState({ sidebarOpened: false });

  handleToggle = () => this.setState({ sidebarOpened: true });

  render() {
    const { children } = this.props;
    const { sidebarOpened } = this.state;

    return (
      <Responsive
        as={Sidebar.Pushable}
        getWidth={getWidth}
        maxWidth={Responsive.onlyMobile.maxWidth}
      >
        <Sidebar
          as={Menu}
          animation="push"
          inverted
          onHide={this.handleSidebarHide}
          vertical
          visible={sidebarOpened}
        >
          <MenuItems
            fixed={false}
            activeItem="projects"
            displayRecruitment={displayRecruitment}
          />
        </Sidebar>

        <Sidebar.Pusher dimmed={sidebarOpened}>
          <Segment
            inverted
            textAlign="center"
            style={{
              padding: "1em 0em",
              backgroundColor: "#111111"
            }}
            vertical
          >
            <Container>
              <Menu inverted pointing secondary size="large">
                <Menu.Item onClick={this.handleToggle}>
                  <Icon name="sidebar" />
                </Menu.Item>
                <Menu.Item position="right">
                  <Button as="a" href="#/login" inverted>
                    Log in
                  </Button>
                </Menu.Item>
              </Menu>
            </Container>
            <div />
          </Segment>
          {children}
        </Sidebar.Pusher>
      </Responsive>
    );
  }
}

MobileNav.propTypes = {
  children: PropTypes.node
};

const ResponsiveContainer = ({ children }) => (
  <div>
    <DesktopNav>{children}</DesktopNav>
    <MobileNav>{children}</MobileNav>
  </div>
);

ResponsiveContainer.propTypes = {
  children: PropTypes.node
};

class ProjectsPage extends Component {
  state = { activePage: 1, projects: [], totalPages: "" };

  handlePaginationChange = (e, { activePage }) => {
    let projectsToBeRendered = [];
    fetch(LINKS.SERVER_BASE_URL + LINKS.SERVER_ROUTES.get5Projects + activePage)
      .then(response => response.json())
      .then(data => {
        // console.log(data);
        data["projects"].forEach(function(project) {
          projectsToBeRendered.push(
            <ProjectCard key={project.id} data={project} />
          );
        });
        this.setState({
          projects: projectsToBeRendered,
          activePage: activePage
        });
      })
      .catch(error => {
        console.log(error);
      });
  };

  componentWillMount = () => {
    // console.log(this.state);
    let projectsToBeRendered = [];
    fetch(
      LINKS.SERVER_BASE_URL +
        LINKS.SERVER_ROUTES.get5Projects +
        this.state.activePage
    )
      .then(response => response.json())
      .then(data => {
        // console.log(data);
        data["projects"].forEach(function(project) {
          projectsToBeRendered.push(
            <ProjectCard key={project.id} data={project} />
          );
        });
        this.setState({
          projects: projectsToBeRendered,
          totalPages: Math.ceil(data["total_pages"])
        });
      })
      .catch(error => {
        console.log(error);
      });
  };

  render() {
    // console.log(this.state)
    return (
      <ResponsiveContainer>
        <Container style={{ marginBottom: "3em" }}>
          <Header
            textAlign="center"
            style={{ marginTop: "1em" }}
            as='h2'
          >
            <Header.Subheader style={{fontSize: '0.7em'}}><strong>A listing of summary of our DIY projects.</strong></Header.Subheader>
            <Header.Subheader style={{fontSize: '0.5em'}}>For more information on each project, check the links in the description (if any).</Header.Subheader>
            <Header.Subheader style={{fontSize: '0.5em'}}>Click on the collaborator tags to check Member profiles.</Header.Subheader>
          </Header>
          <Segment style={{ minHeight: 400, marginBottom: "2em" }} >
            <Item.Group divided>{this.state.projects}</Item.Group>
          </Segment>
          <Grid>
            <Grid.Column textAlign="center">
              <Pagination
                secondary
                pointing
                activePage={this.state.activePage}
                onPageChange={this.handlePaginationChange}
                totalPages={this.state.totalPages}
                // firstItem={null}
                // lastItem={this.state.totalPages}
                boundaryRange={1}
                siblingRange={1}
                // prevItem={null}
                // disabled={this.state.activePage === 4}
                // nextItem={null}
              />
            </Grid.Column>
          </Grid>
        </Container>
        <Footer />
      </ResponsiveContainer>
    );
  }
}

export default ProjectsPage;
